// Restaurant staff & staff-invitation types (restoside app).

export type RestaurantStaffRole = 'manager' | 'waiter' | 'chef' | 'cashier'

/** 'owner' is the synthetic top-level role returned by the backend. */
export type RestaurantRole = 'owner' | RestaurantStaffRole

export type RestaurantStaffInvitationStatus = 'pending' | 'accepted' | 'rejected'

export const RESTAURANT_STAFF_ROLES: { value: RestaurantStaffRole; label: string }[] = [
  { value: 'manager', label: 'Manager' },
  { value: 'waiter', label: 'Waiter' },
  { value: 'chef', label: 'Chef' },
  { value: 'cashier', label: 'Cashier' },
]

export const ROLE_LABELS: Record<RestaurantRole, string> = {
  owner: 'Owner',
  manager: 'Manager',
  waiter: 'Waiter',
  chef: 'Chef',
  cashier: 'Cashier',
}

export interface RestaurantStaffMember {
  _id: string
  id: string
  userId: string
  name: string
  email: string
  avatar?: string | null
  role: RestaurantRole
  isOwner: boolean
}

export interface RestaurantStaffListResponse {
  myRole: RestaurantRole | null
  staff: RestaurantStaffMember[]
}

export interface RestaurantStaffInvitation {
  _id: string
  id: string
  restaurant: {
    _id: string
    id: string
    name: string
    restaurantType: string
  } | null
  sender: {
    _id: string
    id: string
    name: string
    email: string
    avatar?: string | null
  }
  recipient: {
    _id: string
    id: string
    name: string
    email: string
    avatar?: string | null
  }
  role: RestaurantStaffRole
  status: RestaurantStaffInvitationStatus
  readAt?: string | null
  createdAt: string
  updatedAt: string
}
